import React from 'react';
import i18n from 'i18next';

import {
  Flex,
  Text,
} from 'web-styled';

import {
  Tooltip,
} from 'web-components';

import WorkoutIndicator from '../../WorkoutIndicator';
import * as S from './styled';

type Props = {
  data: {
    main: string,
  },
};

const Indicators = ({ data }: Props) => (
  <Flex
    align="center"
    spacing={30}
  >
    {data.events_scheduled_this_week_count !== data.events_scheduled_last_week_count && (
    <S.CounterProgress>
      {data.events_scheduled_this_week_count > data.events_scheduled_last_week_count ? (
        <S.PositiveDynamic />
      ) : (
        <S.NegativeDynamic />
      )}
    </S.CounterProgress>
    )}
    <Flex
      column
      align="center"
      justify="center"
      spacing={8}
    >
      <Text
        color="#757575"
        size="40px"
        lineHeight="40px"
      >
        {data.events_scheduled_this_week_count || 0}
        /
        {data.events_scheduled_last_week_count || 0}
      </Text>
      <Text
        size="10px"
        color="#757575"
        align="center"
        lineHeight="11px"
        whiteSpace="pre-line"
      >
        {i18n.t('dashboard.scheduled.this.week')}
      </Text>
    </Flex>
    <WorkoutIndicator
      text={i18n.t('dashboard.client.completed.this.week')}
      total={data.events_scheduled_this_week_count}
      completed={data.events_completed_this_week_count}
    />
    <Flex column spacing={25}>
      <Flex
        align="center"
        spacing={8}
      >
        <Text
          color="#757575"
          size="40px"
          lineHeight="40px"
        >
          {data.events_scheduled_tomorrow_count || 0}
        </Text>
        <Text
          color="#757575"
          size="10px"
          lineHeight="11px"
          whiteSpace="pre-line"
        >
          {i18n.t('dashboard.scheduled.tomorrow')}
        </Text>
      </Flex>
      <Tooltip
        body={i18n.t('tooltip.dashboard.calendar.button')}
        preferPlace="right"
      >
        <S.Link to="/calendar">
          My Calendar
        </S.Link>
      </Tooltip>
    </Flex>
  </Flex>
);

export default Indicators;
